'use strict';
import $ from 'jquery';

export default class Hubspot {
    static init() {
        $('[data-hubspot-form-id]').each((index, el) => {
            new Hubspot($(el));
        });

        $.fn.onClassChange = function (cb) {
            return $(this).each((_, el) => {
                new MutationObserver(mutations => {
                    mutations.forEach(mutation => cb && cb(mutation.target, mutation.target.className));
                }).observe(el, {
                    attributes: true,
                    attributeFilter: ['class'] // only listen for class attribute changes 
                });
            });
        }
    }

    constructor($el) {
        const self = this;
        this.el = $el;
        const target = $('<div>', {
            id: this.makeid(12)
        });
        this.el.prepend(target);
        // console.log("el: ", this.el);
        let formData = {};
        const hubspotOptions = {
            region: "na1",
            css: '',
            cssClass: 'blueshift-hs-form hs-form',
            portalId: "6313294",
            formId: this.el.data('hubspot-form-id'),
            target: '#' + target.attr('id'),
            onFormReady: ($form) => {
                // Move legal consent to be below the submit button
                let legal_container = this.el.find('.legal-consent-container').parent();
                if (legal_container.is('form')) {
                    legal_container = this.el.find('.legal-consent-container');
                }
                legal_container.insertAfter(this.el.find('.hs-submit'));

                // Check the opt in box by default
                setTimeout(() => this.el.find('.legal-consent-container').find('input[type=checkbox]').prop('checked', true), 750);

                // Ambassador funtionality
                if (this.el.find('input[name=referral_code_ambassador__c]').length > 0) {
                    console.log("ambassador");
                    const data = JSON.parse(localStorage.getItem('mbsy/cookie'));
                    const params = new URLSearchParams(window.location.href);
                    let campaign_id;
                    let short_code;
                    if (data) {
                        campaign_id = data['value']['mbsy_cookie_campaign'];
                        short_code = data['value']['mbsy_cookie_code'];
                    };
                    if (!campaign_id && params.has('campaignid')) {
                        campaign_id = params.get('campaignid');
                    };
                    if (!short_code && params.get('mbsy')) {
                        short_code = params.get('mbsy');
                    };
                    if (short_code && short_code.includes('+')) short_code.replace('+', ' ');
                    if (short_code && short_code.includes('%')) short_code.replace('%', ' ');
                    console.log(campaign_id, short_code, '<--- the variables');
                    const arr = Array.from($form);
                    let updated = false;
                    if (short_code) {
                        console.log("update form");
                        arr.forEach((a, i) => {
                            if (a.name && a.name === 'referral_code_ambassador__c') {
                                a.value = short_code;
                                updated = true;
                                console.log(a, i, '<--- updated short code');
                            };
                        });
                    };
                    if (short_code && !updated) {
                        for (let key in $form[0]) {
                            if ($form[0][key] && $form[0][key] && $form[0][key].name === 'referral_code_ambassador__c') {
                                $form[0][key].value = short_code;
                                console.log($form[0][key], '<--- updated short code');
                            };
                        };
                    };
                    if (!updated) {
                        console.log('Form was not updated, please inspect script');
                    };
                }
                self.el.trigger('onFormReady');
            },
            onFormSubmit: ($form) => {
                formData = $form.serializeArray();
            },
            onFormSubmitted: ($form) => {
                this.el.find('.hubspot-legal-language').hide();
                if (typeof drift !== 'undefined' && typeof drift.api !== 'undefined' && this.el.hasClass('blueshift-hubspot-form-drift')) {
                    const driftOptions = {
                        campaignId: 2677815
                    };
                    if (this.el.data('redirect-url')) {
                        driftOptions.followupUrl = this.el.data('redirect-url');
                    }
                    // console.log("form data: ", formData);
                    drift.api.collectFormData(formData, driftOptions);
                    if (this.el.find('.hubspot-thank-you')) {
                        this.el.find('.hubspot-thank-you').show();
                    }
                } else {
                    this.onSubmitted();
                }

                // console.log("form submitted!");
            }
        };

        if (this.el.find('.hubspotParameters').length > 0) {
            this.el.find('.hubspotParameters').find('input[type=hidden]').each((index, el) => {
                if ($(el).attr('name') in hubspotOptions === false)
                    hubspotOptions[$(el).attr('name')] = $(el).val();
            });
        }
        // console.log("options: ", hubspotOptions);
        hbspt.forms.create(hubspotOptions);
        $(window).on('resize', this.onResize.bind(this));
        setTimeout(() => this.onResize(), 500);
    }

    onSubmitted() {
        if (this.el.find('.hubspot-thank-you')) {
            this.el.find('.hubspot-thank-you').show();
        }
        if (this.el.data('redirect-url')) {
            window.location = this.el.data('redirect-url');
        }
    }

    onResize() {
        let height = $(".hbspt-form .legal-consent-container").height();
        $('.hs-submit').css('margin-bottom', height + 'px');
    }

    makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return 'hubspot-form-' + result;
    }
}
